if (!customElements.get('cart-variant-switch')) {
  customElements.define(
    'cart-variant-switch',
    class CartVariantSwitch extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.button.addEventListener('click', this.switchVariant.bind(this));
      }

      async switchVariant() {
        this.button.disabled = true;
        this.button.classList.add('loading');
        try {
          const addResponse = await fetch(routes.cart_add_url, {
            ...fetchConfig(),
            body: JSON.stringify({
              items: [{ id: Number(this.dataset.variantId), quantity: Number(this.dataset.quantity) }],
            }),
          });
          if (!addResponse.ok) throw new Error('add failed');

          const changeResponse = await fetch(routes.cart_change_url, {
            ...fetchConfig(),
            body: JSON.stringify({
              id: this.dataset.lineKey,
              quantity: 0,
              sections: 'cart-drawer,cart-icon-bubble',
              sections_url: window.location.pathname,
            }),
          });
          const state = await changeResponse.json();

          if (state.sections && state.sections['cart-drawer']) {
            const drawerInner = document.querySelector('#CartDrawer .drawer__inner');
            const newDrawer = new DOMParser()
              .parseFromString(state.sections['cart-drawer'], 'text/html')
              .querySelector('.drawer__inner');
            if (drawerInner && newDrawer) drawerInner.innerHTML = newDrawer.innerHTML;
          }
          if (state.sections && state.sections['cart-icon-bubble']) {
            const bubble = document.getElementById('cart-icon-bubble');
            const newBubble = new DOMParser()
              .parseFromString(state.sections['cart-icon-bubble'], 'text/html')
              .querySelector('.shopify-section');
            if (bubble && newBubble) bubble.innerHTML = newBubble.innerHTML;
          }
        } catch (error) {
          this.button.disabled = false;
          this.button.classList.remove('loading');
        }
      }
    }
  );
}
